import { onMouseDown } from './onMouseDown';
import { onMouseMove } from './onMouseMove';
import { onMouseUp } from './onMouseUp';
import { onClick } from './onClick';

export const getMouseEvents = $ => {
  return {
    onMouseDown: onMouseDown($),
    onMouseMove: onMouseMove($),
    onMouseUp: onMouseUp($),
    onClick: onClick($),
  };
};
